import React, { useState } from "react";
import classnames from "classnames/bind";
import { connect } from "react-redux";

import { setSurroundingId } from "src/redux/surrounding/actions";
import css from "./index.scss";

const cx = classnames.bind(css);
const moduleName = "Surroundings";

const SURROUNDINGS = [
  { id: 1, title: "법흥 계곡", content: "신선이 놀다갔다 해도 믿을 법흥 계곡, JTBC 캠핑클럽 촬영지, 차로 오분 거리", url: "/Surrounding1.jpeg" },
  { id: 2, title: "잔디밭", content: "넓은 잔디밭에서, 족구 축구를 즐기세요.", url: "/Surrounding2.jpeg" },
  { id: 3, title: "산책로", content: "잔디밭 옆 산책로 입니다.", url: "/Surrounding3.jpeg" },
  { id: 4, title: "맑은 하늘", content: "맑은하늘의 모습입니다.", url: "/Surrounding4.jpeg" },
  { id: 5, title: "천렵으로 잡은 고기", content: "천렵으로 잡은 고기입니다.", url: "/Surrounding5.jpeg" },
  { id: 6, title: "쏘가리", content: "이런 쏘가리들을 펜션 옆 강에서 잡을 수 있답니다.", url: "/Surrounding6.jpeg" },
  { id: 7, title: "천렵", content: "손님이 사장님과 천렵을 하는 모습입니다.", url: "/Surrounding7.jpeg" },
  { id: 8, title: "천렵", content: "낚시를 하지 못해도 사장님이 친절히 알려준답니다.", url: "/Surrounding8.jpeg" },
  { id: 9, title: "천렵", content: "사장님께서 열심히 낚시하는 방법을 알려주고 있습니다.", url: "/Surrounding9.jpeg" },
];

const SURROUNDINGS_YEONGWOL = [
  { id: 1, title: "한반도지형", content: "한반도 전체를 옮겨놓은듯한 지형", url: "/Yeongwol1.jpeg" },
  { id: 2, title: "청령포", content: "단종의 유배지", url: "/Yeongwol2.jpeg" },
  { id: 3, title: "장릉", content: "조선 6대 왕 단종이 잠든곳", url: "/Yeongwol3.jpeg" },
  { id: 4, title: "고씨동굴", content: "4억년의 신비를 엿볼수있는 고씨가족의 피난 동굴", url: "/Yeongwol4.jpeg" },
  { id: 5, title: "별마로천문대", content: "국내 시민천문대중 최대 규모", url: "/Yeongwol5.jpeg" },
];

const TYPES = ["펜션주변", "영월관내볼거리"];

const Surroundings = ({ surrounding, setSurroundingId }) => {
  const [selectedType, setSelectedType] = useState("펜션주변");

  const handleSetType = (val) => {
    if (val !== selectedType) setSurroundingId({ id: 1 });
    setSelectedType(val);
  };

  const currentList = selectedType === "펜션주변" ? SURROUNDINGS : SURROUNDINGS_YEONGWOL;
  const selected = currentList.find((v) => v.id === surrounding.id) || currentList[0];

  return (
    <div className={cx(moduleName)}>
      <div className={cx(`${moduleName}-header`)}>
        <div className={cx(`${moduleName}-header-wrapper`)} />
        <div className={cx(`${moduleName}-header-content`)}>
          <p className={cx(`${moduleName}-header-label`)}>Nature</p>
          <h2>주변전경</h2>
          <h4>펜션에서 즐기는 수려한 자연과 영월의 명소</h4>
        </div>
      </div>

      {/* Category toggle */}
      <div className={cx(`${moduleName}-tabs`)}>
        {TYPES.map((val) => (
          <button
            key={val}
            className={cx(`${moduleName}-tab`, { active: val === selectedType })}
            onClick={() => handleSetType(val)}
          >
            {val}
          </button>
        ))}
      </div>

      {/* Main layout: selected info + thumbnail grid */}
      <div className={cx(`${moduleName}-body`)}>
        {/* Left: selected info panel */}
        <div className={cx(`${moduleName}-panel`)} data-aos="fade-right">
          <div className={cx(`${moduleName}-panel-img`)}>
            <img src={require(`./assets${selected.url}`)} alt={selected.title} />
          </div>
          <div className={cx(`${moduleName}-panel-info`)}>
            <h3 className={cx(`${moduleName}-panel-title`)}>{selected.title}</h3>
            <p className={cx(`${moduleName}-panel-desc`)}>{selected.content}</p>
          </div>
        </div>

        {/* Right: thumbnail grid */}
        <div className={cx(`${moduleName}-grid`)}>
          {currentList.map((item, i) => (
            <button
              key={item.id}
              className={cx(`${moduleName}-thumb`, { active: item.id === surrounding.id })}
              onClick={() => setSurroundingId({ id: item.id })}
            >
              <div className={cx(`${moduleName}-thumb-inner`)}>
                <img src={require(`./assets${item.url}`)} alt={item.title} />
                <div className={cx(`${moduleName}-thumb-overlay`)}>
                  <span>{item.title}</span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default connect(
  ({ surrounding }) => ({ surrounding }),
  { setSurroundingId }
)(Surroundings);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Surroundings/index.js